
import React, { useState, useEffect } from "react";
import "../Styles/CloudProProjectConfig.css";
import { FaEdit, FaTrash, FaSave, FaPlus } from "react-icons/fa";

import defaultPanelData from "../Assets/defaultPanelData/defaultPanelData.json";
import Axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import CloudProContentButton from "./CloudProContentButton";
import { panelFromProjectDocument } from "./workflowPanelData";
import panelVersions from "../Config/panelVersions.json";
import Card from '@mui/material/Card';
import { Backdrop, CircularProgress } from "@mui/material";
import CardContent from '@mui/material/CardContent';
import { Snackbar, Alert } from "@mui/material";
export default function CloudProProjectConfig() {
  // for panelversion
  const defaultVersion = panelVersions?.[0] || "2.0.F7";
  const [panelVersion, setPanelVersion] = useState(
    localStorage.getItem("panelVersion") || defaultVersion
  );

  const [data, setData] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const stored = sessionStorage.getItem("selectedProject");
    if (stored) {
      setSelectedProject(JSON.parse(stored));
    }
  }, []);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [showPopup, setShowPopup] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [selectedLoop, setSelectedLoop] = useState(0);
  const [errorsConfig, setErrorsConfig] = useState({});
  const [matrixTemplates, setMatrixTemplates] = useState([]);
const [templatesLoading, setTemplatesLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    panelName: "",
    panelNumber: "",
    client: "",
    location: "",
    status: "Pending",
    matrixTemplateKey: "default",
  });
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(data.length / rowsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { mdId } = useParams();
  const siId = localStorage.getItem("siId") || "";

  useEffect(() => {
    fetchList();
  }, []);


const fetchList = async () => {
  try {
    const email = localStorage.getItem("userEmail") || "";

    const res = await Axios.post("/api/cause-effect-workflow/projects/list", {
      email,
    });

   

    if (res?.data?.success) {
      const rows = Array.isArray(res.data.projects) ? res.data.projects : [];

      const list = rows.map((r) => ({
        id: r.project_id,
        project_id: r.project_id,
        name: r.project_name || "",
        status: r.status || "Active",
        create_time:
          r.created_at ??
          r.create_time ??
          r.createdAt ??
          r.created_time ??
          r.createTime ??
          r.created ??
          null,
        updated_at:
          r.updated_at ??
          r.update_time ??
          r.updatedAt ??
          r.last_modify_time ??
          null,
        revision: r.revision,
        workflow: r.workflow,
        panel_count: r.panel_count,
        loaded: false,
        panel: null,
      }));

      setData(list);
    } else {
      setData([]);
      console.error("Project list failed:", res?.data);
    }
  } catch (err) {
    console.error(
      "Cause-effect project list error:",
      err.response?.status,
      err.response?.data || err
    );
    setData([]);
  }
};
const fetchMatrixTemplates = async () => {
  setTemplatesLoading(true);

  try {
    const res = await Axios.post(
      "/get_cause_effect_matrix_templates"
    );

   

    if (res?.data?.success) {
      setMatrixTemplates(res.data.templates || []);
    } else {
      setMatrixTemplates([]);
      console.error(
        "Failed to load matrix templates",
        res?.data
      );
    }
  } catch (error) {
    console.error(
      "Matrix templates API failed:",
      error
    );
  } finally {
    setTemplatesLoading(false);
  }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrorsConfig((prev) => ({ ...prev, [name]: "" }));
  };


const loadProject = async (project) => {
  try {
  
    const response = await Axios.post(
      "/api/cause-effect-workflow/projects/get",
      {
        email: localStorage.getItem("userEmail") || "",
        projectId: project.project_id,
      }
    );

    if (
      response.data?.success === false ||
      response.data?.error

    ) {
      console.error("API returned an error:", response.data);
      setAlertMsg(
        response.data?.message || response.data?.error ||
        "Unable to load project."
      );
      setOpenSnackbar(true);
      return;
    }

    const variantsResponse = await Axios.post("/get_customer_project", {
      mdId, siId, projectId: project.project_id,
    });
    if (!variantsResponse.data?.success) {
      throw new Error(variantsResponse.data?.msg || "Unable to load project panels.");
    }
    const variants = (variantsResponse.data.projectVariants || []).filter(
      (variant) => variant.panelContent_id
    );
    const storedPanelId = sessionStorage.getItem("panelContentId");
    const storedPanelNumber = sessionStorage.getItem("causeEffectPanelNumber");
    const selectedVariant = variants.find((v) => v.panelContent_id === storedPanelId)
      || (storedPanelNumber && variants.find((v) => String(v.vtnetPanelAddress) === storedPanelNumber))
      || variants[0];
    let panel = null;
    if (selectedVariant) {
      const panelResponse = await Axios.post("/get_customer_panel", {
        mdId, siId, projectId: project.project_id,
        panelContentId: selectedVariant.panelContent_id,
      });
      if (!panelResponse.data?.success || !panelResponse.data.panel) {
        throw new Error(panelResponse.data?.msg || "Unable to load panel configuration.");
      }
      panel = panelFromProjectDocument(panelResponse.data.panel, {
        panelNumber: Number(selectedVariant.vtnetPanelAddress),
      });
      sessionStorage.setItem("panelContentId", selectedVariant.panelContent_id);
      sessionStorage.setItem("causeEffectPanelNumber", String(selectedVariant.vtnetPanelAddress));
    } else {
      sessionStorage.removeItem("panelContentId");
      sessionStorage.removeItem("causeEffectPanelNumber");
    }

    const updatedProject = {
      ...project,
      loaded: true,
      panel,
    };

    setSelectedProject(updatedProject);
    setData((prev) =>
      prev.map((item) =>
        item.project_id === project.project_id
          ? updatedProject
          : item
      )
    );

    sessionStorage.setItem(
      "selectedProject",
      JSON.stringify(updatedProject)
    );
    sessionStorage.setItem("selectedProjectName", project.name);

    navigate(`/${mdId}/layout/cloudprocauseeffect`);
  } catch (error) {
    console.error("Load project failed:", error);
  

    setAlertMsg(
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to load project."
    );
    setOpenSnackbar(true);
  }
};
  const handleSave = () => {
    let newErrors = {};
    const projectName = form.name.trim();
    if (!form.name.trim()) newErrors.name = "Project name is required";
    
    const isDuplicate = data.some(
      (p) => p.name.trim().toLowerCase() === projectName.toLowerCase()
    );

    if (isDuplicate) {
      newErrors.name = "Project name already exists!";

    }

    setErrorsConfig(newErrors);
    if (Object.keys(newErrors).length > 0) return;

  
  Axios.post("/api/cause-effect-workflow/projects/create", {
  email: localStorage.getItem("userEmail") || "",
  projectName: form.name.trim(),
})
      .then((res) => {
        
        if (res?.data?.success) {
          setOpenSnackbar(true);
          setAlertMsg("Project created successfully!");
          setAlertType("success");

          setForm({
            name: "",
            panelName: "",
              matrixTemplateKey: "default",
          });
          setSelectedLoop(0);
          setShowPopup(false);
          fetchList();
        } else {
          setOpenSnackbar(true);
          setAlertMsg("Failed to create project.");
          setAlertType("error");
        }
      })
      .catch((err) => {
        console.error("Create project error:", err);

        setOpenSnackbar(true);
        setAlertMsg("Failed to create project.");
        setAlertType("error");
      });

    const projectData = {
      ...form,
      id: editRow ?? Date.now(),
      loop: selectedLoop ?? 0,
      loaded: false,
      panel: null,
    };

    if (editRow) {
      setData(data.map((d) => (d.id === editRow ? projectData : d)));
    } else {
      setData([...data, projectData]);
    }

    setShowPopup(false);
  };


 const handleDelete = async () => {
  if (!deleteId) return;

  const project = deleteId;
  const email = localStorage.getItem("userEmail") || "";

  try {
 
    let revision = project.revision;

    if (revision == null) {
      const devRes = await Axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/cause-effect-workflow/devices/list`,
        { email, projectId: project.project_id }
      );
      revision = devRes.data?.revision;
 
    }

    const payload = {
      email,
      projectId: project.project_id,
      expectedRevision: revision,
    };
    const res = await Axios.post(
      "/api/cause-effect-workflow/projects/delete",
      payload
    );
  

    if (res?.data?.success) {
      setData((prev) => prev.filter((r) => r.project_id !== project.project_id));

      if (selectedProject?.project_id === project.project_id) {
        setSelectedProject(null);
        sessionStorage.removeItem("selectedProject");
        sessionStorage.removeItem("selectedProjectName");
      }

      setAlertType("success");
      setAlertMsg(`Project '${project.name}' deleted.`);
      setCurrentPage(1);
      fetchList();
    } else {
      setAlertType("error");
      setAlertMsg(res?.data?.message || res?.data?.error || "Failed to delete project.");
    }
  } catch (err) {
    console.error("DELETE error:", err.response?.status, err.response?.data || err);
    setAlertType("error");
    setAlertMsg(
      err.response?.data?.message ||
        err.response?.data?.error ||
        "Delete API failed."
    );
  } finally {
    setOpenSnackbar(true);
    setDeleteId(null);
  }
};
  const formatDate = (date) =>
    new Date(date).toLocaleString("en-IN", {
      dateStyle: "medium",
      timeStyle: "short",
    });
  // below code for workflow selection
 
  useEffect(() => {
    const stored = sessionStorage.getItem("selectedProject");
    if (stored) {
      setSelectedProject(JSON.parse(stored));
    }
  }, []);
  return (
    <> <Backdrop open={loading} sx={{ color: '#fff', zIndex: 9999 }}
     >
      <CircularProgress color="inherit" />
    </Backdrop>
      <div className="project-container">

        <div className="glass-card">

          <Card sx={{ minWidth: 275 }}>
            <CardContent>
              <div className="header">
                <div className="left-actions">
                 <button
  className="add-btn"
  onClick={() => {
    setForm((prev) => ({
      ...prev,
      matrixTemplateKey: "default",
    }));

    fetchMatrixTemplates();
    setShowPopup(true);
  }}
>
  <FaPlus /> Create Project
</button>
                </div>
                <div className="right-actions">
                  {/* <CloudProContentButton selectedProject={selectedProject} panelVersion={panelVersion} /> */}
                </div>
              </div>

              <table className="project-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
               
<tbody>
  {currentRows.map((row) => (
    <tr
      key={row.project_id}
      onClick={() => loadProject(row)}
      style={{ cursor: "pointer" }}
    >
      <td
        className={
          selectedProject?.project_id === row.project_id
            ? "selected-text"
            : ""
        }
      >
        {row.name}
      </td>

      <td>
        {row.create_time ? formatDate(row.create_time) : "-"}
      </td>

      <td>
        {row.updated_at ? formatDate(row.updated_at) : "-"}
      </td>

      <td>
        <span className={`status ${row.status.toLowerCase()}`}>
          {row.status}
        </span>
      </td>

      <td className="actions">
        <button
          className="delete"
          onClick={(e) => {
            e.stopPropagation();
            setDeleteId(row);
          }}
        >
          <FaTrash />
        </button>
      </td>
    </tr>
  ))}
</tbody>
              </table>

              <div className="pagination-container">
                <div className="rows-dropdown">
                  <span>Rows per page: </span>
                  <select
                    value={rowsPerPage}
                    onChange={(e) => {
                      setRowsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                  </select>
                </div>

                <div className="pagination">
                  <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    {"<<"}
                  </button>
                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      onClick={() => paginate(i + 1)}
                      className={currentPage === i + 1 ? "active" : ""}
                    >
                      {i + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    {">>"}
                  </button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Popup for new project */}
        {showPopup && (
          <div className="popup">
            <div className="popup-content large">
              <h6>Create Project</h6>
              <input
                name="name"
                placeholder="Project Name"
                value={form.name}
                onChange={handleChange}
                className={errorsConfig.name ? "input-error" : ""}
              />
              {errorsConfig.name && <p className="error-text">{errorsConfig.name}</p>}

            

             

              <div className="popup-actions">
                <button onClick={handleSave} className="add-btn">
                  <FaSave /> {editRow ? "Save" : "Create"}
                </button>
                <button onClick={() => setShowPopup(false)} className="cancel-btn">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Below function is for delete project */}
        {deleteId && (
          <div className="popup">
            <div className="popup-content small">
              <h6>⚠️ Delete Project?</h6>
              <p>
                Are you sure you want to delete <b>{deleteId.name}</b>?
              </p>
              <div className="popup-actions">
                <button className="add-btn" onClick={handleDelete}>
                  Delete
                </button>
                <button className="cancel-btn" onClick={() => setDeleteId(null)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

      
        <Snackbar open={openSnackbar} autoHideDuration={3000} onClose={() => setOpenSnackbar(false)}>
          <Alert onClose={() => setOpenSnackbar(false)} severity={alertType} variant="filled">
            {alertMsg}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}
